import React from 'react';

interface QCReport {
  timestamp: string;
  issue: string;
  severity: string;
  // Optional customer-facing fields populated by the backend humanizer.
  // Older API payloads won't have them — we fall back to ``issue``.
  title?: string;
  detail?: string;
  category?: string;
  recommended_action?: string | null;
}

interface QCReportCardProps {
  report: QCReport;
}

const QCReportCard: React.FC<QCReportCardProps> = ({ report }) => {
  const headline = report.title || report.issue;
  const body = report.detail && report.detail !== headline ? report.detail : '';
  return (
    <div className="qc-report-card">
      <div className="qc-header">
        <span className="timestamp">{report.timestamp}</span>
        <span className={`severity ${report.severity.toLowerCase()}`}>{report.severity}</span>
        {report.category && <span className="category">{report.category}</span>}
      </div>
      <div className="qc-issue">
        <strong>{headline}</strong>
        {body && <p className="qc-detail">{body}</p>}
        {report.recommended_action && (
          <p className="qc-action">
            <strong>Recommended action:</strong> {report.recommended_action}
          </p>
        )}
      </div>
    </div>
  );
};

export default QCReportCard;
